import React from 'react';
import PropTypes from 'prop-types';
import { compose, contains } from 'ramda';
import { withTranslation } from 'react-i18next';
import { ButtonsContainer, ButtonWithLoader } from 'virtues-bootstrap';
import { reduxForm } from 'redux-form';

import { FORM_NAMES } from 'constants/forms';
import { RESEARCHER, SUPER_RESEARCHER, SUPER_TECHNICIAN } from 'constants/userRoles';

import DetailedEPReportFrom from './From';

import validate from './validate';
import s from './styles.module.scss';

const disabledRoles = [RESEARCHER, SUPER_RESEARCHER, SUPER_TECHNICIAN];

const DetailedEPReport = ({ role, pristine, handleSubmit, submitting, t, reportStatus }) => {
  const disabled = contains(role, disabledRoles) || reportStatus !== 'registered';

  return (
    <form onSubmit={handleSubmit}>
      <DetailedEPReportFrom disabled={disabled} />
      {!disabled && (
        <ButtonsContainer className={s.saveBtn}>
          <ButtonWithLoader disabled={pristine} loading={submitting}>
            {t('detailedEPReport.saveChanges')}
          </ButtonWithLoader>
        </ButtonsContainer>
      )}
    </form>
  );
};

DetailedEPReport.propTypes = {
  role: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  reportStatus: PropTypes.string,
};

DetailedEPReport.defaultProps = {
  reportStatus: null,
};

export default compose(
  withTranslation(),
  reduxForm({
    form: FORM_NAMES.detailedEPReport,
    enableReinitialize: true,
    validate,
  }),
)(DetailedEPReport);
